import * as Yup from 'yup';
import { REQUIRED_FIELD } from '../../../../constants';

const AssetsValidationSchema = Yup.object().shape({
  title: Yup.string().required(REQUIRED_FIELD),
});

export default AssetsValidationSchema;
